// extracted by mini-css-extract-plugin
export default {"viewLoading":"spinner_viewLoading__jijDh","spinner":"spinner_spinner__C5oqG","load8":"spinner_load8__2UA+5"};